import { render } from "./UpdateOrgDetailsDialog.vue?vue&type=template&id=3747c8d9"
import script from "./UpdateOrgDetailsDialog.vue?vue&type=script&lang=js"
export * from "./UpdateOrgDetailsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__